import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAllSites } from '../services/api';
import { DEMO, useDemo } from '../components/DemoModal';
import type { Site } from '../types';

const blank = (): Partial<Site> => ({ site_id: '', name: '', address: '', city: '', state: '' });

export default function Sites() {
  const { showDemo } = useDemo();
  const { data } = useQuery({ queryKey: ['sites-all'], queryFn: getAllSites });
  const [draft, setDraft] = useState<Partial<Site>>(blank());
  const [err, setErr] = useState<string | null>(null);

  const submit = () => {
    setErr(null);
    if (!draft.site_id) {
      setErr('site id is required');
      return;
    }
    showDemo(DEMO.saveSite);
  };

  const sites = data?.sites ?? [];

  return (
    <div className="page-wrap">
      <h2>Sites</h2>
      <div className="card" style={{ padding: 16, marginBottom: 20 }}>
        <h3 style={{ marginTop: 0 }}>Add / update a site</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
          <div>
            <label className="field">Site ID</label>
            <input className="input" value={draft.site_id ?? ''} onChange={(e) => setDraft({ ...draft, site_id: e.target.value })} />
          </div>
          <div>
            <label className="field">Name</label>
            <input className="input" value={draft.name ?? ''} onChange={(e) => setDraft({ ...draft, name: e.target.value })} />
          </div>
          <div>
            <label className="field">Address</label>
            <input className="input" value={draft.address ?? ''} onChange={(e) => setDraft({ ...draft, address: e.target.value })} />
          </div>
          <div>
            <label className="field">City</label>
            <input className="input" value={draft.city ?? ''} onChange={(e) => setDraft({ ...draft, city: e.target.value })} />
          </div>
          <div>
            <label className="field">State</label>
            <input className="input" value={draft.state ?? ''} onChange={(e) => setDraft({ ...draft, state: e.target.value })} />
          </div>
        </div>
        {err && <p style={{ color: 'var(--danger)' }}>{err}</p>}
        <button className="btn btn-primary" style={{ marginTop: 12 }} onClick={submit}>
          Save site
        </button>
      </div>

      <table className="data-table card" style={{ display: 'table' }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Address</th>
            <th>City</th>
            <th>Coords</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {sites.map((s) => (
            <tr key={s.site_id}>
              <td>{s.site_id}</td>
              <td>{s.name ?? '—'}</td>
              <td>{s.address ?? '—'}</td>
              <td>{[s.city, s.state].filter(Boolean).join(', ')}</td>
              <td>{s.lat != null && s.lon != null ? `${Number(s.lat).toFixed(3)}, ${Number(s.lon).toFixed(3)}` : '—'}</td>
              <td>
                <button className="btn btn-sm" onClick={() => setDraft(s)}>
                  Edit
                </button>{' '}
                <button className="btn btn-sm btn-danger" onClick={() => showDemo(DEMO.deleteSite)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
